<div class="rise-agent-chart">
    <canvas #chartCanvas></canvas>
</div>
